import { find, get, isNil } from 'lodash';
import rewardTypes from '@enums/reward-types';
import requirementTypes from '@enums/requirement-types';

const getTier = (offerMechanic, tierIndex) => get(offerMechanic, ['tiers', tierIndex], {});

export const getTierRewards = (offerMechanic, tierIndex) => {
    const tier = getTier(offerMechanic, tierIndex);
    return [...get(tier, 'productOfferGroups[0].rewards', []), ...get(tier, 'globalRewards', [])];
};

export const getTierRequirements = (offerMechanic, tierIndex) => {
    const tier = getTier(offerMechanic, tierIndex);
    return [
        ...get(tier, 'productOfferGroups[0].requirements', []),
        ...get(tier, 'globalRequirements', []),
    ];
};

export const getTierPrimaryReward = (offerMechanic, tierIndex) =>
    getTierRewards(offerMechanic, tierIndex)[0] || null;

export const getTierRequirementAmount = (offerMechanic, tierIndex, type) => {
    const requirement = find(getTierRequirements(offerMechanic, tierIndex), { type });
    return requirement && !isNil(requirement.amount) ? requirement.amount : null;
};

export const getTierFreeItems = (offerMechanic, tierIndex) => {
    const reward = find(getTierRewards(offerMechanic, tierIndex), { type: rewardTypes.getNFree });
    return reward && !isNil(reward.amount) ? reward.amount : null;
};

export const getUnitsPerTrigger = offerMechanic => {
    const free = getTierFreeItems(offerMechanic, 0);
    if (!free) return 1;
    const buy = getTierRequirementAmount(offerMechanic, 0, requirementTypes.buyNumber) || 0;
    return buy + free;
};

export default {
    getTierRewards,
    getTierRequirements,
    getTierPrimaryReward,
    getTierRequirementAmount,
    getTierFreeItems,
    getUnitsPerTrigger,
};
